import React, { Suspense, useState } from "react";
import {
    AppBar,
    Avatar,
    Box,
    IconButton,
    Toolbar,
    Typography,
} from "@mui/material";
import {
    Menu as MenuIcon,

} from "@mui/icons-material";
import { Outlet } from "react-router-dom";
import LoadingSpinner from "../components/LoadingSpinner";
import CustomerDrawer from "../sections/header/CustomerDrawer";
import useThemeColors from "../pages/vehicle/ThemeColors";
import { Loader } from "react-bootstrap-typeahead";
import { useGetGeoLocationMutation } from "../Services/vehicle/Vehicle";
import { toast } from "react-toastify";


interface IPROPS {
    liftingName:any
    setStoreGeoLocationData:any
    storedGeoLoaction:any
    setStoreVehicleInfo:any
    storeVehicleInfo:any
    setOpenVehicleModal:any
    setOpenModal:any
    setIsWorkshopSelectorClicked:any
    setIsCartOpen:any
    vehicleData:any
    setCurrentStep:any
    homeApiData:any

}


const CustomerMasterLayout: React.FC<IPROPS> = ({setCurrentStep,homeApiData, vehicleData, setIsCartOpen,setIsWorkshopSelectorClicked, setOpenModal, setOpenVehicleModal,setStoreGeoLocationData, storedGeoLoaction, setStoreVehicleInfo, storeVehicleInfo}) => {
        const [addressValue, setAddressValue] = useState("");
        const [geoLoctionLoader, setGeoLocationLoader] = useState(false);

        const getUserName = JSON.parse(localStorage.getItem("login-type") || "{}");
        
        const [geoLocationTrigger, { status }] = useGetGeoLocationMutation();
        
        const getLocation = async (e: any) => {
            e.preventDefault();
            const locationPayload = {
                address: addressValue,
            };
            setGeoLocationLoader(true)
            try {
                const response = await geoLocationTrigger(locationPayload);
    
                setStoreGeoLocationData(response?.data);
                if (response?.data) {
                    toast.success("Location fetched successfully");
                } else if (response?.error) {
                    toast.error("unabel to find the location")
                }
            } catch (error) {

            }

            finally {
                setGeoLocationLoader(false)
            }
        };

    return (
       

            // <Box
            //     component="main"
            //     sx={{
            //         flexGrow: 1,
            //         // bgcolor: "#f3f4f6",

            //         p: 3,
            //         height: "100%",
            //         mt: "64px",

            //     }}
            //     style={{background: "white"}}
            // >
            <div>

            <CustomerDrawer 
            setOpenVehicleModal={setOpenVehicleModal}
            setOpenModal={setOpenModal}
            setIsWorkshopSelectorClicked={setIsWorkshopSelectorClicked}
            setIsCartOpen={setIsCartOpen}
            vehicleData={vehicleData}
            setCurrentStep={setCurrentStep}
            homeApiData={homeApiData}

           
         storedGeoLoaction={storedGeoLoaction} setStoreGeoLocationData={setStoreGeoLocationData}  setStoreVehicleInfo={setStoreVehicleInfo} storeVehicleInfo={storeVehicleInfo}/>
                   <div className="post d-flex flex-column-fluid" id="kt_post">
                              <div id="kt_content_container" className="w-100">
                                <Suspense fallback={<LoadingSpinner />}>
                                  <Outlet/>
                                </Suspense>
                              </div>
                            </div>
            </div>
            // </Box>
    );
};

export default CustomerMasterLayout;